import type { MessagingViewState } from '@frontend/constants';

// Single source of truth for the instance-relative /messages URL scheme (default
// `messages` tab omitted). Keep in sync with the backend resolver
// notification-service/app/adapters/messaging/deep_links.py.
export function buildMessagesPath(state: Partial<MessagingViewState>): string {
  if (state.view === 'compose') {
    // Recipients and draft text are deliberately not encoded — the URL is
    // shareable, and a half-addressed draft is not something to hand to someone
    // else or restore verbatim on reload.
    return '/messages/new';
  }
  if (state.view === 'mentions') {
    return '/messages/mentions';
  }
  if (state.view === 'threads') {
    return '/messages/threads';
  }
  if (!state.conversationId) {
    return '/messages';
  }
  const params = new URLSearchParams();
  if (state.conversationTab && state.conversationTab !== 'messages') {
    params.set('tab', state.conversationTab);
  }
  if (state.threadPanelId) {
    params.set('thread', state.threadPanelId);
  }
  if (state.targetMessageId) {
    params.set('messageId', state.targetMessageId);
  }
  const qs = params.toString();
  return `/messages/conversations/${encodeURIComponent(state.conversationId)}${qs ? `?${qs}` : ''}`;
}
